// extracted by mini-css-extract-plugin
export default {"categoryCardImage":"CategoryCard-module__categoryCardImage--TsUQD","categoryCard":"CategoryCard-module__categoryCard--aqyBd"};